<script>
    import DesktopButton from '../../reusableitems/DesktopButton2.svelte';
</script>

    <div class="sectionHolder">
        <div class="contentPart">
            <h6>STORYTELLERS & Opus</h6>
            <h1>PRODUCERS</h1>
            <p style="width:34.352vh; margin: 0 0 2.593vh;">
                Nothing is more satisfying than seeing your production come to life.
                In the future which we’re building, it isn't a year long project
                around gathering a team, resources and equipment, rather it’s an
                exercise in narrative.
            </p>
            <p style="width:39.167vh;margin: 0 0 6.944vh;">
                <b>
                    Rather than waiting till the end to see the result, we start
                    with the production and the time is spent in tweaking and
                    refining the experience rather than hoping that the budget
                    lasts. Interested in buildlign that future alongside us?
                </b>
            </p>
            <div>
                <DesktopButton
                    state = "StoryTeller"
                    text2="(Producers Seat)"
                    text1="Join Storytellers Governance Council"
                    AnimationColor="#a53bd6"
                    BorderColorAfter="0.0052vw solid #a53bd6"
                />
            </div>
        </div>
        <div class="imgOuterWrraper">
            <div class="imgWrraper">
                <img
                    src="/images/create-section/Rectangle.png"
                    alt="arrow"
                    width="100%"
                    height="100%"
                />
            </div>
        </div>
        <div class="imgWrraper2">
            <img
                src="/images/create-section/assets.png"
                alt="assets"
                width="100%"
                height="100%"
            />
        </div>
    </div>



<style>
    .sectionHolder {
        background-color: #f4eeec;
        width: 188.259vh;
        position: relative;
    }
    .contentPart {
        width: 40.833vh;
        top: 24.352vh;
        left: 11.019vh;
        font-family: "Orbitron";
        position: absolute;
        font-style: normal;
        z-index: 1;
    }
    h6 {
        font-weight: 400;
        font-size: 1.296vh;
        line-height: 100%;
        text-transform: uppercase;
        color: #000000;
        margin: 0;
    }
    h1 {
        font-weight: 900;
        font-size: 5.556vh;
        line-height: 100%;
        text-transform: uppercase;
        color: #a53bd6;
        margin: 1.481vh 0px 3.426vh;
    }
    p {
        font-weight: 400;
        font-size: 1.296vh;
        line-height: 140%;
        letter-spacing: 0.09em;
        color: #000000;
    }
    .imgOuterWrraper {
        width: 144.398vh;
        overflow: hidden;
        margin-left: auto;
    }
    .imgOuterWrraper::after{
        position: absolute;
        content: "";
        height: 100%;
        width: 100%;
        background-color: #ffffff00;
        left: 0;
        top: 0;
    }
    .imgWrraper {
        width: 144.398vh;
        height: 100vh;
        transform: translateX(10vh);
    }
    .imgWrraper2 {
        width: 114.167vh;
        height: 64.259vh;
        right: 13.5vh;
        top: 17.407vh;
        position: absolute;
        filter: grayscale(100%);
        transition-duration: 0.8s;
    }
    .imgWrraper2:hover {
        filter: grayscale(0%);
        transition-duration: 0.8s;
    }
    .imgWrraper2::after{
        position: absolute;
        content: "";
        height: 100%;
        width: 100%;
        background-color: #ffffff00;
        left: 0;
        top: 0;
    }
</style>
